<template>
  <div class="scroll-slider mx-md-n16 px-md-16">
    <div
      class="grid-row grid-row_sm d-flex_wrap d-flex_sm-nowrap grid-row_sm-xs"
    >
      <div
        v-for="item in getProductUtp"
        :key="item.id"
        class="grid-col grid-col_50 pt-8 grid-col_xl-100 grid-col_lg-50 grid-col_sm-auto"
      >
        <Detail
          :picture="item.preview_picture"
          :title="item.name"
          :text="item.preview_text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Detail from "../Detail/Detail.vue";
import { mapState } from "pinia";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";

export default {
  name: "DetailsBlock",
  components: {
    Detail,
  },
  computed: {
    ...mapState(useProductStore, ["getProductUtp"]),
  },
};
</script>
